import { render, staticRenderFns } from "./CalibrationsView.vue?vue&type=template&id=8f8cfd60&scoped=true&"
import script from "./CalibrationsView.vue?vue&type=script&lang=js&"
export * from "./CalibrationsView.vue?vue&type=script&lang=js&"
import style0 from "./CalibrationsView.vue?vue&type=style&index=0&id=8f8cfd60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8cfd60",
  null
  
)

export default component.exports